import { render } from "./UpkeepContractViewadd.vue?vue&type=template&id=70d09872"
import script from "./UpkeepContractViewadd.vue?vue&type=script&lang=js"
export * from "./UpkeepContractViewadd.vue?vue&type=script&lang=js"

import "./UpkeepContractViewadd.vue?vue&type=style&index=0&id=70d09872&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__